import {
  daysOverdue,
  gestionesOf,
  montoPagado,
  saldoPendiente,
} from './cobranzas';

function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function scoreLabel(score) {
  if (score == null) return '—';
  if (score >= 80) return 'Excelente';
  if (score >= 60) return 'Bueno';
  if (score >= 40) return 'Regular';
  return 'Riesgo';
}

export function scoreClient(invoices = []) {
  if (!invoices.length) {
    return { score: null, label: '—', impagas: 0, brokenPromises: 0 };
  }

  let total = 0;
  let cobrado = 0;
  let impagas = 0;
  let overdueDaysSum = 0;
  let overdueCount = 0;
  let severe = 0;
  let brokenPromises = 0;
  const today = todayISO();

  for (const inv of invoices) {
    const t = Number(inv.total) || 0;
    total += t;
    cobrado += montoPagado(inv);

    if (saldoPendiente(inv) > 0.009) {
      impagas += 1;
      const days = daysOverdue(inv);
      if (days > 0) {
        overdueDaysSum += days;
        overdueCount += 1;
        if (days > 60) severe += 1;
      }
      for (const g of gestionesOf(inv)) {
        if (g.tipo === 'promesa' && g.promesaFecha) {
          const prom = String(g.promesaFecha).slice(0, 10);
          if (prom < today) brokenPromises += 1;
        }
      }
    }
  }

  const collectionRate = total > 0 ? cobrado / total : 1;
  const avgOverdueDays = overdueCount > 0 ? overdueDaysSum / overdueCount : 0;
  const score = Math.min(100, Math.max(0, Math.round(
    collectionRate * 40
    + Math.max(0, 30 - Math.min(30, avgOverdueDays / 2))
    + Math.max(0, 20 - severe * 5)
    + Math.max(0, 10 - brokenPromises * 3)
  )));

  return {
    score,
    label: scoreLabel(score),
    impagas,
    brokenPromises,
  };
}

export function scoresFromInvoices(invoices = []) {
  const map = {};
  for (const inv of invoices) {
    const key = inv.razonSocial || inv.cliente || 'Sin cliente';
    if (!map[key]) map[key] = [];
    map[key].push(inv);
  }

  const out = {};
  for (const [cliente, list] of Object.entries(map)) {
    out[cliente] = scoreClient(list);
  }
  return out;
}
